window.Coterie = module.exports = (function() {

    var obj = {};

    obj.setToken = function(token) {
        obj.token = token;
    };

    obj.setEnvironment = function(environment) {
        obj.environment = environment;
    };

    obj.startQuoteFlow = function(request) {
        console.log(request);

        var xmlHttp = new XMLHttpRequest();

        xmlHttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var response = JSON.parse(this.responseText);
                console.dir(response);
                if (response.isSuccess) {
                    var applicationUrl = response.quote.applicationUrl;
                    if (applicationUrl) {
                        window.location.href = applicationUrl;
                        return;
                    }
                }
                console.error("There was a problem getting the application URL");
            } else if (this.status >= 400) {
                console.error("There was a problem getting the application URL");
            }
        };

        var environment = (request || obj).environment;
        xmlHttp.open("POST", getBaseUrl(environment) + "/commercial/quotes");

        var token = (request || obj).token;
        xmlHttp.setRequestHeader("Authorization", "token " + token);

        xmlHttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        var requestData = JSON.stringify(request);
        xmlHttp.send(requestData);
    };

    obj.createCoterieButton = function(request) {
        console.log(request);
        var link = document.createElement("a");
        link.href = "javascript:false";
        link.innerText = request.text || "Get insurance from Coterie";
        link.dataset.request = JSON.stringify(request);
        link.setAttribute("onclick", "Coterie.startQuoteFlow(JSON.parse(this.dataset.request))");
        link.setAttribute("class", "coterie-button " + request.cssClass);
        if (!request.cssClass) {
            link.setAttribute("style",
                "-moz-box-shadow:inset 0px 1px 0px 0px #fce2c1;" +
                "-webkit-box-shadow:inset 0px 1px 0px 0px #fce2c1;" +
                "box-shadow:inset 0px 1px 0px 0px #fce2c1;" +
                "background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #ff8a14), color-stop(1, #ffab57));" +
                "background:-moz-linear-gradient(top, #ff8a14 5%, #ffab57 100%);" +
                "background:-webkit-linear-gradient(top, #ff8a14 5%, #ffab57 100%);" +
                "background:-o-linear-gradient(top, #ff8a14 5%, #ffab57 100%);" +
                "background:-ms-linear-gradient(top, #ff8a14 5%, #ffab57 100%);" +
                "background:linear-gradient(to bottom, #ff8a14 5%, #ffab57 100%);" +
                "filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff8a14', endColorstr='#ffab57',GradientType=0);" +
                "background-color:#ff8a14;" +
                "-moz-border-radius:6px;" +
                "-webkit-border-radius:6px;" +
                "border-radius:6px;" +
                "border:1px solid #ffa142;" +
                "display:inline-block;" +
                "cursor:pointer;" +
                "color:#ffffff;" +
                "font-family:Arial;" +
                "font-size:14px;" +
                "font-weight:bold;" +
                "padding:6px 12px;" +
                "text-decoration:none;" +
                "text-shadow:0px 1px 0px #c48827;");
        }

        return link;
    };

    function getBaseUrl(environment) {
        var baseUrl = "https://api.coterieinsurance.com/v1";
        if (environment === "local") {
            baseUrl = "http://localhost:5000/v1";
        } else if (environment) {
            baseUrl = "https://api-" + environment + ".coterieinsurance.com/v1";
        }
        return baseUrl;
    }

    var request;
    for (var memberName in document.currentScript.dataset) {
        if (!request) {
            request = {};
        }
        request[memberName] = document.currentScript.dataset[memberName];
    }
    if (request) {
        var button = obj.createCoterieButton(request);
        document.write(button.outerHTML);
    }

    return obj;
})();
